import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export const DialogFooter = ({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "tw-flex tw-items-center tw-justify-end tw-border-t tw-border-blue-100 tw-bg-blue-100/15 tw-px-4 tw-py-[14px]",
        {
          [className]: !!className,
        },
      )}
    >
      {children}
    </div>
  );
};
